/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./distributionPolicy.defs.js";
export { main as default } from "./distributionPolicy.defs.js";
